<template>
    <div class="container salesManagement_wrap">
        <p class="page_title">매출현황</p>
        <section class="section sec1">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">매출현황</p>
                </div>
                <div class="rightbox"></div>
            </div>
            <div class="card_box">
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/ico_total.png`" alt="" class="icon">
                        <span class="txt">총 매출</span>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc">
                                <span class="word">
                                    <span class="num">{{ currentMonth.total_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc point">
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/ico_apple.png`" alt="" class="icon">
                        <span class="txt">애플앱 매출</span>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc">
                                <span class="word">
                                    <span class="num">{{ currentMonth.apple_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc point">
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_apple_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/ico_goole.png`" alt="" class="icon">
                        <span class="txt">구글앱 매출</span>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc">
                                <span class="word">
                                    <span class="num">{{ currentMonth.google_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc point">
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_google_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section sec2">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">Plan별 매출</p>
                </div>
                <div class="rightbox">
                    <div class="sales_info">
                        이번달 <span class="month">{{ curMonthInfo.length }}개</span>
                        / 오늘 <span class="today">{{ currentMonth.today_count }}개</span>
                    </div>
                </div>
            </div>
            <div class="card_box">
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/ico_p.png`" alt="" class="icon">
                        <span class="txt">Premium</span>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc">
                                <span class="word">
                                    <span class="num">{{ currentMonth.premium_count }}</span>개
                                </span>
                                <span class="word">
                                    <span class="num">{{ currentMonth.premium_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc point">
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_premium_count }}</span>개
                                </span>
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_premium_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/ico_b.png`" alt="" class="icon">
                        <span class="txt">Basic</span>
                    </div>
                    <div class="desc_box">
                        <div class="item">
                            <p class="tit">이번 달</p>
                            <p class="desc">
                                <span class="word">
                                    <span class="num">{{ currentMonth.basic_count }}</span>개
                                </span>
                                <span class="word">
                                    <span class="num">{{ currentMonth.basic_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                        <div class="item">
                            <p class="tit">오늘</p>
                            <p class="desc point">
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_basic_count }}</span>개
                                </span>
                                <span class="word">
                                    <span class="num">{{ currentMonth.today_basic_price.toLocaleString() }}</span>원
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section sec3">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">결제건수 ˑ 매출 추이</p>
                </div>
                <div class="rightbox">
                    <div class="filter_box">
                        <button type="button" id="chart1_daybtn" class="filter_btn day"
                            :class="{ 'on': chartType == 0 }" @click="chartType = 0">일별</button>
                        <button type="button" id="chart1_monthbtn" class="filter_btn month"
                            :class="{ 'on': chartType == 1 }" @click="chartType = 1">월별</button>
                    </div>
                </div>
            </div>
            <div class="chart_box">
                <div class="chart_top">
                    <div class="select_box" v-if="chartType == 0">
                        <select class="select" v-model="selectedMonth" @change="changeMonth(selectedMonth)">
                            <option value="1">1월</option>
                            <option value="2">2월</option>
                            <option value="3">3월</option>
                            <option value="4">4월</option>
                            <option value="5">5월</option>
                            <option value="6">6월</option>
                            <option value="7">7월</option>
                            <option value="8">8월</option>
                            <option value="9">9월</option>
                            <option value="10">10월</option>
                            <option value="11">11월</option>
                            <option value="12">12월</option>
                            <option value="13">기간</option>
                        </select>
                    </div>
                    <div class="select_box" v-if="chartType == 1">
                        <select class="select" v-model="selectedYear" @change="changeChartYearData(selectedYear)">
                            <option value="2025">2025년</option>
                            <option value="2026">2026년</option>
                            <option value="2027">2027년</option>
                            <option value="2028">2028년</option>
                            <option value="2029">2029년</option>
                        </select>
                    </div>
                    <div class="input_box date" v-if="isDatePicker">
                        <VueDatePicker range :model-value="rangeDate" @update:model-value="searchFilter" :enable-time-picker="false"
                            :clearable="false" :teleport="true" />
                    </div>
                </div>
                <div class="chart" v-if="chartType == 0">
                    <Bar :options="chartOptions" :data="chartData" />
                </div>
                <div class="chart" v-if="chartType == 1">
                    <Bar :options="chartOptions" :data="chartData2" />
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { getPaymentQuote, getPaymentQuoteMonth, getPaymentQuoteYear } from '@/api';
import { Bar } from 'vue-chartjs'
import { ref, computed } from 'vue';
import { createGradient } from '@/utils';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement)
const curMonthInfo = ref([])
const chartType = ref(0)
const selectedYear = ref(new Date().getFullYear());
const isDatePicker = computed(() => {
    if (selectedMonth.value == 13) {
        return true;
    } else {
        return false;
    }
})

const selectedMonth = ref(new Date().getMonth() + 1);
async function getPaymentQuoteData(start, end) {
    const res = await getPaymentQuote(start, end);
    curMonthInfo.value = res.data.list
}

async function changeChartYearData(year) {
    const res = await getPaymentQuoteYear(year);
    chartMonthLabels2.value = res.data.list.map(item => {
        return item.month
    });
    chartMonthPrice2.value = res.data.list.map(item => {
        return item.pricing
    });
    chartMonthNum2.value = res.data.list.map(item => {
        return item.count
    });
}

const searchFilter = async (modelData) => {
    rangeDate.value = modelData
    const [start, end] = modelData;

    const startDate = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`;
    const endDate = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`;
    const res = await getPaymentQuoteMonth(startDate, endDate);
    chartMonthLabels.value = res.data.paymentNum.map(item => {
        return item.date
    });
    chartMonthNum.value = res.data.paymentNum.map(item => {
        return item.count
    });
    chartMonthPrice.value = res.data.paymentPrice.map(item => {
        return item.total_pricing
    });
}

const chartMonthLabels = ref([]);
const chartMonthLabels2 = ref([]);
const chartMonthNum = ref([]);
const chartMonthNum2 = ref([]);
const chartMonthPrice = ref([]);
const chartMonthPrice2 = ref([]);
const rangeDate = ref([])
const chartData = computed(() => {
    return {
        labels: chartMonthLabels.value,
        datasets: [
            {
                type: 'line',
                data: chartMonthPrice.value,
                label: "매출",
                borderColor: '#008ee8',
                borderWidth: 3.5,
                pointBackgroundColor: '#fff',
                pointRadius: 6,
                pointBorderWidth: 3.5,
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#008ee8',
                pointHoverRadius: 8,
                pointHoverBorderWidth: 3.5,
                yAxisID: 'y',
                order: 0,
            },
            {
                label: '결제 건수',
                data: chartMonthNum.value,
                backgroundColor: function (context) {
                    return createGradient(context, '#9750F8', '#3E1AD6');
                },
                borderRadius: 8,
                barThickness: 24,
                type: 'bar',
                yAxisID: 'y2',
                order: 1,
            },
        ]
    }
})

const chartData2 = computed(() => {
    return {
        labels: chartMonthLabels2.value,
        datasets: [
            {
                type: 'line',
                data: chartMonthPrice2.value,
                label: "매출",
                borderColor: '#008ee8',
                borderWidth: 3.5,
                pointBackgroundColor: '#fff',
                pointRadius: 6,
                pointBorderWidth: 3.5,
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#008ee8',
                pointHoverRadius: 8,
                pointHoverBorderWidth: 3.5,
                yAxisID: 'y',
                order: 0,
            },
            {
                label: '결제 건수',
                data: chartMonthNum2.value,
                backgroundColor: function (context) {
                    return createGradient(context, '#9750F8', '#3E1AD6');
                },
                borderRadius: 8,
                barThickness: 24,
                type: 'bar',
                yAxisID: 'y2',
                order: 1,
            },
        ]
    }
})

const minValue = computed(() => {
    return Math.min(...chartMonthPrice.value);
})
const maxValue = computed(() => {
    return Math.max(...chartMonthPrice.value);
})



const stepCount = computed(() => {
    return (maxValue.value - minValue.value) / 10000 + 1
})

const stepSize = computed(() => {
    if (stepCount.value > 6) {
        return Math.ceil((maxValue.value - minValue.value) / 5 / 10000) * 10000;
    } else {
        return 10000;
    }
})

const rangeCount = computed(() => {
    return Math.ceil((maxValue.value - minValue.value) / stepSize.value + 1);
})

const chartOptions = computed(() => {
    return {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 0,
                left: -18,
                right: 0,
                bottom: 0,
            }
        },
        scales: {
            x: {
                offset: true,
                ticks: {
                    padding: 12,
                    font: {
                        family: 'Pretendard',
                        weight: '400',
                        size: 13,
                        color: '#40395d',
                    },
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: false,
                position: 'left',
                ticks: {
                    stepSize: stepSize.value,
                    padding: 18,
                    font: {
                        family: 'Pretendard',
                        weight: '400',
                        size: 13,
                        color: '#383b40',
                    },
                    callback: function (value) {
                        if (minValue.value - stepSize.value * 3 >= 0 && minValue.value - stepSize.value * 2 >= 0 && minValue.value -
                            stepSize.value >= 0) {
                            if (rangeCount.value === 4 && value === minValue.value - stepSize.value * 2) {
                                return '0';
                            } else if (rangeCount.value <= 3 && rangeCount.value > 6 && value === minValue.value -
                                stepSize.value * 3) {
                                return '0';
                            }
                        }
                        return value;
                    },
                },
                min: (function () {
                    if (minValue.value - stepSize.value * 3 > 0 && minValue.value - stepSize.value * 2 > 0 && minValue.value -
                        stepSize.value > 0) {
                        if (rangeCount.value === 6) {
                            return;
                        } else if (rangeCount.value === 5) {
                            return minValue.value - stepSize.value;
                        } else if (rangeCount.value === 4) {
                            return minValue.value - stepSize.value * 2;
                        } else if (rangeCount.value === 3 || rangeCount.value === 2 || stepCount.value === 1) {
                            return minValue.value - stepSize.value * 3;
                        }
                    } else {
                        return 0;
                    }
                })(),
                max: (function () {
                    if (minValue.value - stepSize.value * 3 > 0 && minValue.value - stepSize.value * 2 > 0 && minValue.value -
                        stepSize.value > 0) {
                        if (rangeCount.value === 2) {
                            return maxValue.value + stepSize.value;
                        } else if (rangeCount.value === 1) {
                            return maxValue.value + stepSize.value * 2;
                        } else {
                            return;
                        }
                    } else {
                        if (rangeCount.value === 3) {
                            return maxValue.value + stepSize.value * 1;
                        } else if (rangeCount.value === 2) {
                            return maxValue.value + stepSize.value * 2;
                        } else if (rangeCount.value === 1) {
                            return maxValue.value + stepSize.value * 3;
                        } else {
                            return;
                        }
                    }
                })(),
                border: {
                    display: false,
                },
            },
            y2: {
                beginAtZero: true,
                position: 'right',
                ticks: {
                    stepSize: 1,
                    padding: 18,
                    font: {
                        family: 'Pretendard',
                        weight: '400',
                        size: 13,
                        color: '#383b40',
                    },
                    autoSkip: true,
                },
                border: {
                    display: false,
                },
            },
        },
    }
})

onMounted(() => {
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    getPaymentQuoteData(`${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`, `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`);
    changeChartYearData(new Date().getFullYear())
    changeMonth(new Date().getMonth() + 1);
})

async function changeMonth(value) {
    if (value == 13) {
        return
    }
    const startDate = new Date(new Date().getFullYear(), value - 1, 1);
    const endDate = new Date(new Date().getFullYear(), value, 0);
    const res = await getPaymentQuoteMonth(`${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`, `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`);
    chartMonthLabels.value = res.data.paymentNum.map(item => {
        return item.date
    });
    chartMonthNum.value = res.data.paymentNum.map(item => {
        return item.count
    });
    chartMonthPrice.value = res.data.paymentPrice.map(item => {
        return item.total_pricing
    });
}

const currentMonth = computed(() => {
    let data = {
        total_price: 0,
        today_price: 0,
        apple_price: 0,
        today_apple_price: 0,
        google_price: 0,
        today_google_price: 0,
        premium_price: 0,
        today_premium_price: 0,
        premium_count: 0,
        today_premium_count: 0,
        basic_price: 0,
        today_basic_price: 0,
        basic_count: 0,
        today_basic_count: 0,
        free_price: 0,
        today_free_price: 0,
        today_count: 0,
    }
    curMonthInfo.value.forEach(item => {
        data.total_price += item.pricing
        const today = new Date();
        const payDate = new Date(item.pay_date);
        if (payDate.getFullYear() === today.getFullYear() &&
            payDate.getMonth() === today.getMonth() &&
            payDate.getDate() === today.getDate()) {
            data.today_price += item.pricing;
            data.today_count += 1;
        }
        if (item.pay_method === 0) {
            data.apple_price += item.pricing
            if (payDate.getFullYear() === today.getFullYear() &&
                payDate.getMonth() === today.getMonth() &&
                payDate.getDate() === today.getDate()) {
                data.today_apple_price += item.pricing
            }
        }
        if (item.pay_method === 1) {
            data.google_price += item.pricing
            if (payDate.getFullYear() === today.getFullYear() &&
                payDate.getMonth() === today.getMonth() &&
                payDate.getDate() === today.getDate()) {
                data.today_google_price += item.pricing
            }
        }
        if (item.type === 0) {
            data.basic_price += item.pricing
            data.basic_count += 1;
            if (payDate.getFullYear() === today.getFullYear() &&
                payDate.getMonth() === today.getMonth() &&
                payDate.getDate() === today.getDate()) {
                data.today_basic_price += item.pricing
                data.today_basic_count += 1;
            }
        }
        if (item.type === 1) {
            data.premium_price += item.pricing
            data.premium_count += 1;
            if (payDate.getFullYear() === today.getFullYear() &&
                payDate.getMonth() === today.getMonth() &&
                payDate.getDate() === today.getDate()) {
                data.today_premium_price += item.pricing
                data.today_premium_count += 1;
            }
        }
    })
    return data
})

</script>